import classNames from "classnames";
import LinkArrowIcon from "../../assets/img/icons/LinkArrowIcon";
import { analytics } from "../../utils/vendors";
import { Link } from "react-router-dom";

interface ICiroLinkProps {
  href?: string;
  shouldOpenInNewTab?: boolean;
  children?: any;
  unstyled?: boolean;
  onClick?: () => void;
}

const CiroLink = ({
  href,
  children,
  shouldOpenInNewTab = true,
  unstyled = false,
  onClick,
}: ICiroLinkProps) => {
  const handleClick = (e: React.MouseEvent) => {
    if (!href) {
      e.preventDefault();
    }

    analytics.track("linkClicked", {
      href,
    });

    if (onClick) {
      onClick();
    }
  };

  return (
    <Link
      className={classNames({
        "no-underline": !unstyled,
        "text-orange-400": !unstyled,
        "hover:text-orange-500": !unstyled,
      })}
      onClick={handleClick}
      target={shouldOpenInNewTab ? "_blank noopener noreferrer" : undefined}
      to={href || ""}
    >
      {children || <LinkArrowIcon />}
    </Link>
  );
};

export default CiroLink;
